import { RouteRecordRaw } from 'vue-router'

const Login = () =>
  import(/* webpackChunkName: "login-view" */ '@/pages/auth/Login.vue')
const AuthLayout = () =>
  import(/* webpackChunkName: "login-layout" */ '@/layouts/AuthLayout.vue')

export const authRoutes: Array<RouteRecordRaw> = [
  {
    path: '/auth/',
    component: AuthLayout,
    redirect: '/login',
    children: [
      {
        path: 'login',
        name: 'login',
        component: Login,
      },
    ],
  },
]
